import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { ApiAuthService } from '../auth.service';

export const apiAuthGuardWithParams = (params: any = {}) => {
  return (route: ActivatedRouteSnapshot) => {
    const router = inject(Router);
    const apiAuthSrv = inject(ApiAuthService);
    return apiAuthSrv.logged(params).pipe(
      map((result) => {
        if (result) {
          return true;
        } else {
          router.navigate(['/auth/login'], {
            queryParams: {
              redirect: encodeURIComponent((route as any)._routerState.url),
            },
          });
          return false;
        }
      }),
    );
  };
};
export const apiAuthGuard = apiAuthGuardWithParams();
